TextWithIcon.ICONS["--"] = [{
    name: "order_completion_star_png",
    bundle: "reward_icons",
    size: 50
}];

TextWithIcon.ICONS_BY_NAME.orderStar = "--";
